import { render, staticRenderFns } from "./UpdatesAndInsightsComponent.vue?vue&type=template&id=15d4458c"
import script from "./UpdatesAndInsightsComponent.vue?vue&type=script&lang=js"
export * from "./UpdatesAndInsightsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports